import { Capacitor } from '@capacitor/core';

/**
 * True inside the Capacitor iOS/Android shell, false in any browser.
 *
 * Kept behind one helper so components and tests have a single switch for
 * "this is the store app" (no admin tools, native-feeling touch behaviour).
 */
export function isNativePlatform(): boolean {
  try {
    return Capacitor.isNativePlatform();
  } catch {
    return false;
  }
}

/**
 * Tags <html> with `native` in the store app so index.css can apply the
 * app-only touch rules (no text selection or long-press callouts outside
 * form fields). Called once at startup.
 */
export function markNativeShell(root: HTMLElement | null = typeof document === 'undefined' ? null : document.documentElement): boolean {
  const native = isNativePlatform();
  root?.classList.toggle('native', native);
  return native;
}
